import { render, staticRenderFns } from "./AddSaleCategoryCompanyModal.vue?vue&type=template&id=5a64f772&scoped=true&"
import script from "./AddSaleCategoryCompanyModal.vue?vue&type=script&lang=js&"
export * from "./AddSaleCategoryCompanyModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSaleCategoryCompanyModal.vue?vue&type=style&index=0&id=5a64f772&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a64f772",
  null
  
)

export default component.exports